import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
//import { setCurrentMedia } from "Actions";
import Goto from "../Goto";

import Sidebar from "../Sidebar";

//import _ from "i18n";
import { TTP_API_URL } from "Config";

import {
  purifyString
  //getDateLabel,
  //getUserNameForAvatar,
} from "Utils";
import classnames from "classnames";
import styles from "./Viewer.local.scss";

class Content extends PureComponent {
  getPDFPathFromPPT = media => {
    const path = (media.fullMediaUrl
      ? media.fullMediaUrl
      : TTP_API_URL + "/" + media.webPath
    ).substring(
      0,
      media[media.fullMediaUrl ? "fullMediaUrl" : "webPath"].lastIndexOf("/")
    );

    return `${path}/PDF/${media.id}.pdf`;
  };

  renderMedia() {
    const { currentMedia } = this.props.viewer;

    const path =
      currentMedia.docType !== "PPT"
        ? currentMedia.fullMediaUrl
          ? currentMedia.fullMediaUrl
          : `${TTP_API_URL}/${currentMedia.webPath}`
        : this.getPDFPathFromPPT(currentMedia);

    switch (currentMedia.docType) {
      case "VIDEO":
        return (
          <video
            src={path}
            controls
            autoPlay
            style={{
              minWidth: "500px"
            }}
          />
        );

      case "PDF":
      case "PPT":
        return (
          <iframe
            className={styles.pdf_viewer}
            style={{
              width: "100%",
              height: "100%"
            }}
            title={currentMedia.title}
            src={`/pdf-viewer/web/viewer.html?file=${encodeURIComponent(path)}`}
          />
        );
      default:
        return <img alt="" src={path} /*style={styleDimension}*/ />;
    }
  }

  render() {
    const { language, viewer } = this.props;
    const { currentMedia, medias } = viewer;

    if (!currentMedia || !medias) {
      return null;
    }

    const { organization, docType, fullMediaUrl, webPath } = currentMedia;

    const path =
      docType !== "PPT"
        ? fullMediaUrl
          ? fullMediaUrl
          : `${TTP_API_URL}/${webPath}`
        : this.getPDFPathFromPPT(currentMedia);

    const titleAttr = `title${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    const descAttr = `description${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    return (
      <Fragment>
        <div className="cell rmodal__body grid-x article-file">
          <div
            className={classnames(
              styles.media_container,
              "small-12 article-content rmodal__left",
              organization ? "medium-8" : ""
            )}
          >
            <Goto url={path} />
            <div
              className={classnames(
                styles.media,
                docType === "PDF" || docType === "PPT" ? styles.pdf : ""
              )}
              style={
                !organization && (docType === "PDF" || docType === "PPT")
                  ? { height: "85%" }
                  : null
              }
            >
              {this.renderMedia()}
            </div>
            {organization ? (
              <div
                className={classnames(
                  "article-file__organization",
                  styles.organization
                )}
              >
                {organization.abbreviation
                  ? organization.abbreviation
                  : organization.name}
              </div>
            ) : null}
            <div className="article-file__title">
              <h1>{purifyString(currentMedia[titleAttr])}</h1>
            </div>
            {!currentMedia[descAttr] ? null : (
              <div className="article-file__content">
                {currentMedia[descAttr]}
              </div>
            )}
          </div>
          {organization ? (
            <div className="cell small-12 medium-4 article-meta">
              <Sidebar
                currentResource={{
                  ...currentMedia,
                  publishedAt: currentMedia.createdAt,
                  isExternal: true
                }}
                type="MEDIA"
              />
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  viewer: state.mediaViewer,
  auth: state.auth,
  language: state.params.lng
});
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Content);



// WEBPACK FOOTER //
// ./src/components/Reveal/MediaViewer/Content.js